export const ALLOWED_LENGTH = 90;

export default ALLOWED_LENGTH;
